import { Activity, ActivityType } from '@apeiron/common'
import { CurrencyTokenType } from '@apeiron/currency'
import {
  chainNetworkTypeSchema,
  lookupObject,
  publicAccountSchema
} from '@apeiron/temp'
import * as yup from 'yup'

const activityTypeSchema: yup.BaseSchema<ActivityType> = yup
  .mixed()
  .oneOf(Object.values(ActivityType))
  .default(ActivityType.Unknown)

const activityAccount = yup
  .object({
    from: publicAccountSchema,
    to: publicAccountSchema
  })
  .when(['$data'], (data: Record<string, any>) => {
    const activity = lookupObject<any>(data, ['fromAccount', 'toAccount'])

    return yup.object().default({
      from: activity.fromAccount,
      to: activity.toAccount
    })
  })

const activityTransaction = yup
  .object({
    commitAt: yup.string().default(''),
    hash: yup.string().default('')
  })
  .when(['$data'], (data: Record<string, any>) => {
    const activity = lookupObject<any>(data, ['fromAccount', 'toAccount'])

    return yup.object().default({
      commitAt: activity.transactionTime,
      hash: activity.transactionHash
    })
  })

export const activitySchema: yup.SchemaOf<Activity> = yup
  .object({
    account: activityAccount,
    price: yup
      .string()
      .transform(value => value || '0')
      .default('0'),
    currencyType: yup
      .mixed<CurrencyTokenType>()
      .oneOf(Object.values(CurrencyTokenType))
      .default(CurrencyTokenType.Unspecified),
    network: chainNetworkTypeSchema,
    quantity: yup.number().default(0),
    token: yup.string().default('0'),
    transaction: activityTransaction,
    type: activityTypeSchema,
    typeName: yup.string().default('')
  })
  .from('activityType', 'type')
  .from('activityTypeMetaKey.name', 'typeName')
  .from('tokenId', 'token')
  .from('currencyCode', 'currencyType')
  .noUnknown(true)
